import gql from 'graphql-tag';

export const reorderSection = gql(`
  mutation reorderSection($sectionId: UUID!, $contentId: UUID!, $order: Int!) {
    reorderSection(sectionId: $sectionId, contentId: $contentId, order: $order)
  }
`);
